// react
import React from 'react';

// internationalization
import { useTranslation } from 'react-i18next';

// material ui
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

type AIProvider = 'ollama' | 'anthropic' | 'openai' | 'azure';

interface ProviderSelectorProps {
  value: AIProvider;
  onChange: (provider: AIProvider) => void;
}

export const ProviderSelector: React.FC<ProviderSelectorProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value as AIProvider);
  };

  const { t } = useTranslation('ai-assistent');

  return (
    <FormControl size="small" sx={{ minWidth: 120 }}>
      <Select
        value={value}
        onChange={handleChange}
        displayEmpty
        aria-label="AI provider"
        sx={{
          fontSize: '0.775rem',
          fontWeight: 600,
          borderRadius: 3,
          bgcolor: 'background.paper',
          '& .MuiSelect-select': {
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 3,
          },
        }}
      >
        <MenuItem value="ollama">{t('providers.ollama')}</MenuItem>
        <MenuItem value="azure">{t('providers.azure')}</MenuItem>
      </Select>
    </FormControl>
  );
};
